(function () {

	const hamburger = document.querySelector('.mobile-hamburger');
	const navMenu = document.getElementById('site-navigation');

	if (hamburger && navMenu) {
		hamburger.addEventListener('click', function() {
			if (navMenu.classList.contains('menu-open')) {
				closeMenu();
			} else {
				openMenu();
			}
		});

		mobileSubMenuHandling();
	}

	function openMenu() {
		document.dispatchEvent(new CustomEvent('open-mobile-menu'));
		navMenu.classList.add('menu-open');
		document.body.classList.add('prevent-scroll');
	}
	
	function closeMenu() {
		document.dispatchEvent(new CustomEvent('close-mobile-menu'));
		navMenu.classList.remove('menu-open');
		document.body.classList.remove('prevent-scroll');
	}

	/**
	 * WP admin bar handling
	 */
	const adminBar = document.getElementById('wpadminbar');
	if (adminBar) {
		document.body.classList.add('admin-bar-showing');
	}


	function mobileSubMenuHandling() {
		const subMenuOpeners = document.querySelectorAll('.menu-item-has-children > .children-opener');

		function closeSubMenuBranch(menuItem) {
			menuItem.classList.remove('sub-menu-opened');
			menuItem.querySelectorAll('.menu-item-has-children.sub-menu-opened').forEach(openItem => {
				openItem.classList.remove('sub-menu-opened');
			});
		}

		subMenuOpeners.forEach(opener => {
			opener.addEventListener('click', function(e) {
				e.preventDefault();
				const currentMenuItem = this.parentElement;
				const closestSubMenu = currentMenuItem.querySelector(':scope > .sub-menu');

				if (!closestSubMenu) {
					return;
				}

				const isCurrentlyOpen = currentMenuItem.classList.contains('sub-menu-opened');
				const currentLevelList = currentMenuItem.parentElement;

				if (currentLevelList) {
					const sameLevelItems = currentLevelList.querySelectorAll(':scope > .menu-item-has-children');
					sameLevelItems.forEach(levelItem => {
						if (levelItem === currentMenuItem) {
							return;
						}

						closeSubMenuBranch(levelItem);
					});
				}

				closeSubMenuBranch(currentMenuItem);

				if (!isCurrentlyOpen) {
					currentMenuItem.classList.add('sub-menu-opened');
				}
			});
		});
	}

})();